import script from "./PrincipalCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PrincipalCard.vue?vue&type=script&setup=true&lang=js"

import "./PrincipalCard.vue?vue&type=style&index=0&id=3308bfb3&lang=css"

const __exports__ = script;

export default __exports__